import { adsenseConfig } from "./config";

let loadPromise: Promise<void> | null = null;

export const loadAdSenseScript = (): Promise<void> => {
  if (!adsenseConfig.clientId) {
    return Promise.reject(new Error("AdSense publisher ID is not configured"));
  }

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]',
    );
    if (existing) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseConfig.clientId}`;
    script.crossOrigin = "anonymous";
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Failed to load AdSense script"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const pushAdSenseSlot = (element: HTMLElement | null): void => {
  if (!element) return;

  try {
    const queue = (window.adsbygoogle = window.adsbygoogle ?? []);
    queue.push({});
  } catch (error) {
    console.error("AdSense push failed:", error);
  }
};

declare global {
  interface Window {
    adsbygoogle?: Record<string, unknown>[];
  }
}
